import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["originsField"];

  addLocalhost() {
    const field = this.originsFieldTarget;
    const currentValue = field.value.trim();
    const localhost = "http://localhost:3000";

    if (!currentValue.includes(localhost)) {
      field.value = currentValue ? `${currentValue}\n${localhost}` : localhost;
    }
  }
}
